import { useContextState } from '../../../../../../hooks/theme'

function useStyles() {
  const { colors } = useContextState()
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
    detailItem: {
      '& .detail-value': {
        fontSize: '16px',
        fontWeight: '500',
        color: colors.color22,
        wordBreak: 'break-word',
      },
      '& .detail-caption': {
        fontSize: '14px',
        color: colors.color22,
      },
    },
  }
}

export { useStyles }
